import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ShieldAlert, SearchX, AlertTriangle } from 'lucide-react';

// Shared state blocks for the Template Library pages (loading / forbidden / not found / structured error / empty).
export function LibraryLoading({ label = 'Loading Template Library…' }) {
  return <div role="status" aria-live="polite" className="text-center py-12 text-muted-foreground" data-testid="library-loading">{label}</div>;
}

export function LibraryErrorState({ error, onRetry }) {
  if (!error) return null;
  const forbidden = error.status === 403, missing = error.status === 404;
  const Icon = forbidden ? ShieldAlert : missing ? SearchX : AlertTriangle;
  const title = forbidden ? 'You do not have access to this part of the Template Library'
    : missing ? 'Library item not found' : 'The Template Library request could not be completed';
  return (
    <Card data-testid={forbidden ? 'library-forbidden' : missing ? 'library-not-found' : 'library-error'}>
      <CardContent className="py-10 text-center text-muted-foreground" role="alert">
        <Icon className="w-10 h-10 mx-auto mb-3 opacity-50" />
        <p className="font-medium text-foreground">{title}</p>
        <p className="text-sm mt-1" data-testid="library-error-message">{error.message}</p>
        {error.code && <p className="text-xs mt-1 font-mono" data-testid="library-error-code">{error.code}</p>}
        {onRetry && !forbidden && !missing && (
          <button type="button" onClick={onRetry} className="mt-4 text-sm underline" data-testid="library-retry-btn">Try again</button>
        )}
      </CardContent>
    </Card>
  );
}

export function LibraryEmptyState({ title, hint }) {
  return (
    <Card data-testid="library-empty"><CardContent className="py-12 text-center text-muted-foreground">
      <SearchX className="w-12 h-12 mx-auto mb-3 opacity-40" />
      <p className="font-medium">{title}</p>
      {hint && <p className="text-sm mt-1">{hint}</p>}
    </CardContent></Card>
  );
}
